<template>
  <div>
    <div class="login-section">
      <div>
        <p class="sign-in-text">SIGN IN</p>
      </div>

      <!--username or email-->
      <div class="input-icons" style="padding-top: 2px">
        <i class="fa fa-user icon"></i>
        <input
          class="input-field"
          v-validate="'required'"
          v-model="model.empid"
          placeholder="username or email"
          addon-left-icon="tim-icons icon-single-02"
        />
      </div>

      <!--password-->
      <div class="input-icons" style="padding-top: 5px">
        <i class="fa fa-lock icon"></i>
        <input
          class="input-field"
          v-validate="'required'"
          v-model="model.password"
          placeholder="password"
          addon-left-icon="tim-icons icon-single-02"
          :type="type"
        />
        <i class="fa fa-eye icon-eye" @click="reveal()"></i>
      </div>

      <!-- remember user / forgot password -->
      <div
        class="padding-remember"
        style="
          justify-content: space-between;
          display: flex;
          line-height: 1px;
          margin-top: 20px;
        "
      >
        <span style="padding-top: 2px; line-height: 1px">
          <input
            type="checkbox"
            class="rounded-checkbox"
            id="rememberMe"
            v-model="rememberMe"
            value="0"
          />&nbsp;&nbsp;
          <label class="remember-forgot" for="rememberMe"> Remember Me </label>
        </span>

        <p
          class="link remember-forgot padding-forgot"
          @click="forgotPassword()"
        >
          Forgot password?
        </p>
      </div>

      <!--Sign In Button-->
      <!-- margin-left: 20%; -->
      <div style="margin-top: 20px; text-align: center">
        <form @submit.prevent="login">
          <button class="btn-round sign-in-button" type="submit">
            Sign In
          </button>
        </form>

        <!--Loading after submitting form-->
        <div class="col-log d-flex justify-content-center text-center">
          <circle-8 v-if="loading"></circle-8>
        </div>
      </div>

      <!--Error message-->
      <div class="row" v-if="errormsg != ''">
        <div class="col-lg text-center">
          <p class="error-message">{{ errormsg }}</p>
        </div>
      </div>

      <!--Registration-->
      <div>
        <div style="padding-top: 10px; background-color: transparent">
          <div class="no-account-text">
            Don't Have An Account? &nbsp;

            <p class="link register-here-text" @click="getModal()">
              Register Here
            </p>
          </div>
        </div>

        <br />
        <br />

        <div>
          <!--New User Registration-->
          <modal :show.sync="modals.modal1">
            <div class="text-center" style="/*height: 40px;*/ margin-top: 2px">
              <p
                style="
                  color: #5a5a5a;
                  text-align: center;
                  font-size: 22px;
                  font-weight: 600;
                "
              >
                New User Registration
              </p>
            </div>
            <div class="text-center" style="margin-top: -10px">
              <p
                style="
                  color: #9d9d9d;
                  text-align: center;
                  font-size: 20px;
                  font-style: italic;
                  font-weight: 300;
                "
              >
                Please choose type of user
              </p>
            </div>

            <div
              class="text-center"
              style="margin-top: 50px; margin-bottom: 50px"
            >
              <p style="color: #A5A5A5; font-size: 16px; font-weight: 300">
                User type
              </p>

              <!--Select Type-->
              <el-select
                class="select-info tab select-width modal-input"
                placeholder="Select"
                v-model="selects.site"
                style="border-bottom: 1px solid lightgray; font-weight: 800"
                @change="getType()"
                filterable
              >
                <!--Select List-->
                <el-option
                  v-for="option in selects.sites"
                  class="select-info modal-input"
                  :value="option.value"
                  :label="option.label"
                  :key="option.value"
                ></el-option>
              </el-select>
            </div>

            <div style="height: 200px">
              <div v-if="this.selects.site == '2'" class="text-center">
                <p style="color: #A5A5A5; font-size: 16px; font-weight: 300">
                  Land Generator Type
                </p>
                <el-select
                  class="select-info tab select-width modal-input"
                  placeholder="Select"
                  v-model="selects.land"
                  style="border-bottom: 1px solid lightgray"
                  @change="getType()"
                  filterable
                >
                  <el-option
                    v-for="option in selects.lands"
                    class="select-info"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>

              <div v-if="this.selects.site == '3'" class="text-center">
                <p style="color: #A5A5A5; font-size: 16px; font-weight: 300">
                  Vessel Generator Type
                </p>
                <el-select
                  class="select-info tab select-width modal-input"
                  placeholder="Select"
                  v-model="selects.vessel"
                  style="border-bottom: 1px solid lightgray"
                  @change="getType()"
                  filterable
                >
                  <el-option
                    v-for="option in selects.vessels"
                    class="select-info"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <div class="col-lg-12 text-center" style="margin-bottom: 50px">
              <base-button type="danger" v-on:click="closeModal()"
                >Cancel</base-button
              >&nbsp;
              <base-button type="primary" v-on:click="getDone()"
                >Next</base-button
              >
            </div>
          </modal>

          <modal :show.sync="modals.modal2">
            <p>Enter your email</p>
            <p>{{ this.recovertext }}</p>
            <!-- // call message from api -->
            <input
              type="text"
              v-model="recoveremail"
              placeholder="Your email"
              :class="{ 'custom-input': true }"
            />
            <div class="col-lg-12" style="margin-top: 2px">
              <div class="row">
                <div class="col-lg"></div>
                <div class="col-lg-4 text-center">
                  <base-button type="primary" v-on:click="forgetpassword()"
                    >Reset</base-button
                  >
                </div>
              </div>
            </div>

            <div class="col-lg-12"></div>
          </modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, DatePicker, Checkbox } from "element-ui";
import { Circle8 } from "vue-loading-spinner";
import Card from "../../components/Cards/Card.vue";
import { Modal } from "src/components";
import swal from "sweetalert2";
import util from "../../util/util";

export default {
  name: "Login",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    Circle8,
    Card,
    Modal,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      type: "password",
      errormsg: "",
      recoveremail: "",
      recovertext: "",
      rememberMe: false,
      password: "",
      payload: {},
      checked: true,
      loading: false,
      modals: {
        modal1: false,
        modal2: false,
      },
      model: {
        empid: "",
        password: "",
        message: "",
      },

      decodedToken: "",

      role: "",

      positionID: 0,
      roleID: 0,

      selects: {
        site: "land",
        sites: [
          { value: "land", label: "Customer - Land Generator" },
          { value: "vessel", label: "Customer - Vessel Generator" },
          { value: "vendor", label: "Vendor" },
          { value: "authorities", label: "Authorities" },
        ],

        land: "operator",
        lands: [
          { value: "operator", label: "Port Operator" },
          { value: "operation", label: "Port Operation" },
          { value: "tenant", label: "Port Tenant" },
        ],

        vessel: "berthing",
        vessels: [
          { value: "berthing", label: "Vessel berthing" },
          { value: "agent", label: "Shipping agent" },
          { value: "captain", label: "Shipping caption" },
          { value: "owner", label: "Shipping owner" },
        ],
      },
    };
  },
  methods: {
    reveal() {
      if (this.type == "password") {
        this.type = "text";
      } else {
        this.type = "password";
      }
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    submitForm() {
      this.login();
    },
    forgetpassword() {
      let obj = {
        email: this.recoveremail,
      };

      this.$http.post(":10001/api/v1/password/forgot", obj).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          this.recovertext = response;
        } else if (res.error) {
          this.recovertext = res.message.message;
        }
      });
    },

    //login start here
    login() {
      if (this.model.empid != "" && this.model.password != "") {
        this.loading = true;
        const password = this.model.password;
        this.payload = {
          email: this.model.empid,
          //hantar yang encrypt
          password: util.encrypt(this.model.password),
        };
        this.$http
          .post(":10001/api/v1/sign-in", this.payload)
          .then((res) => {
            console.log(res);
            this.loading = false;

            if (res.error) {
              this.errormsg = res.message;
              swal({
                title: `Error!`,
                text: res.message,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-primary btn-fill",
                type: "error",
              });
            } else {
              console.log(
                JSON.parse(atob(res.message.jwt_token.split(".")[1]))
              );

              let roles = JSON.parse(
                atob(res.message.jwt_token.split(".")[1])
              ).role;

              console.log("NMA", roles);

              sessionStorage.setItem("role-name", roles);

              if (this.rememberMe) {
                // sessionStorage.setItem("remember", "rememberme");
                sessionStorage.setItem("rememberme", this.model.empid);
                sessionStorage.setItem("passwordremember", this.model.password);
                localStorage.setItem("token", res.message.jwt_token);
              } else {
                sessionStorage.setItem("remember", "notrememberme");
                sessionStorage.setItem("token", res.message.jwt_token);
              }
              this.$cookie.set("token", res.message.jwt_token);

              if (roles == "Customer - Land Generator") {
                this.$router.push("/Land/Overview");
              } else if (roles == "Customer - Vessel Generator") {
                this.$router.push("/Vessel/Overview");
              } else if (roles == "Vendor") {
                this.$router.push("/Vendor/Overview");
              } else if (roles == "Authorities") {
                this.$router.push("/Authorities/Overview");
              } else {
                // this.$router.push("/Incoming");
                this.$router.push("/overview");
              }
              // }

              this.rememberMe = false;
              this.errormsg = "";
            }
          })
          .catch((err) => {
            this.errormsg = err.response.data.message;
            this.loading = false;
          });
      } else {
        this.errormsg = "Username and password are required!";
      }
    },
    loginSuccessful(req) {
      if (!req.data.token) {
        this.loginFailed();
        return;
      }

      localStorage.token = req.data.token;
      this.error = false;
    },
    loginFailed() {
      this.error = "Login failed!";
      delete localStorage.token;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    //login end here

    getModal() {
      this.modals.modal1 = true;
    },
    closeModal() {
      this.modals.modal1 = false;
    },
    forgotPassword() {
      // this.modals.modal2 = true;
      this.$router.push("/forgotpassword");
    },

    getType() {},

    handleDone() {
      this.selects.sites = [];
      this.selects.lands = [];
      this.selects.vessels = [];

      this.$http.get(":10001/api/v1/setting/roles").then((res) => {
        if (!res.error) {
          let response = res.message;

          for (var i = 1; i < response.length; i++) {
            let obj = {
              label: response[i].role_name,
              value: response[i].role_id,
            };

            this.selects.sites.push(obj);
          }

          for (var j = 0; j < response[1].Position.length; j++) {
            let obj1 = {
              label: response[1].Position[j].position_name,
              value: response[1].Position[j].position_id,
            };
            this.selects.lands.push(obj1);
          }

          for (var k = 0; k < response[2].Position.length; k++) {
            let obj2 = {
              label: response[2].Position[k].position_name,
              value: response[2].Position[k].position_id,
            };
            this.selects.vessels.push(obj2);
          }

          this.selects.site = this.selects.sites[0].value;
          this.selects.land = this.selects.lands[0].value;
          this.selects.vessel = this.selects.vessels[0].value;
        }
      });
    },

    handleEnterKey(event) {
      if (event.key === "Enter") {
        this.login();
      }
    },

    getDone() {
      if (this.selects.site == "2") {
        sessionStorage.setItem("role-id", this.selects.site);
        if (this.selects.land == "5") {
          sessionStorage.setItem("position-id", this.selects.land);
        } else if (this.selects.land == "6") {
          sessionStorage.setItem("position-id", this.selects.land);
        } else if (this.selects.land == "7") {
          sessionStorage.setItem("position-id", this.selects.land);
        }
        this.$router.push("/land-register");
      } else if (this.selects.site == "3") {
        sessionStorage.setItem("role-id", this.selects.site);
        if (this.selects.vessel == "8") {
          sessionStorage.setItem("position-id", this.selects.vessel);
        } else if (this.selects.vessel == "9") {
          sessionStorage.setItem("position-id", this.selects.vessel);
        } else if (this.selects.vessel == "10") {
          sessionStorage.setItem("position-id", this.selects.vessel);
        } else if (this.selects.vessel == "11") {
          sessionStorage.setItem("position-id", this.selects.vessel);
        }
        this.$router.push("/vessel-register");
      } else if (this.selects.site == "4") {
        this.$router.push("/vendor-register");
      } else if (this.selects.site == "5") {
        this.$router.push("/authorities-register");
      }
    },
  },
  created() {
    this.handleDone();

    // reassign remember me value
    if (
      sessionStorage.getItem("rememberme") != null &&
      sessionStorage.getItem("passwordremember") != null
    ) {
      if (sessionStorage.getItem("rememberme")) {
        this.model.empid = sessionStorage.getItem("rememberme");
      }
      if (sessionStorage.getItem("passwordremember")) {
        this.model.password = sessionStorage.getItem("passwordremember");
      }

      this.rememberMe = true;
    }
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.handleEnterKey);
  },
  mounted() {
    document.addEventListener("keyup", this.handleEnterKey);
  },
};
</script>
<style>
/*mobile small*/

.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.input-icons i {
  position: absolute;
}

.input-icons {
  width: 100%;
  margin-bottom: 10px;
  text-align: center;
}

.icon {
  padding-top: 24px;
  min-width: 50px;
  text-align: center;
  color: #c7c7c7;
  padding: 19px;
}

.error-message {
  color: #EC1B23;
  margin-top: 10px;
  font-size: 13px;
}

.icon-eye {
  padding: 18px;
  right: 10%;
  color: #c7c7c7;
  cursor: pointer;
}

.input-field {
  width: 79%;
  padding: 14px;
  padding-left: 50px;
  border-radius: 50px;
  border: 1px solid #c7c7c7;
}

.rounded-checkbox {
  width: 1.3em;
  height: 1.3em;
  border-radius: 50%;
  vertical-align: middle;
  border: 1px solid #707070;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
}
.rounded-checkbox:checked {
  appearance: auto;
  clip-path: circle(50% at 50% 50%);
  background-color: #00f2c3;
}

.choose-type {
  color: #9d9d9d;
  text-align: center;
  font-size: 23px;
  font-style: italic;
  font-weight: 300;
}

h2 {
  color: #0BAA00;
}

.link {
  cursor: pointer;
}
.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

.sign-in-text {
  color: #707070;
  font-size: 5vw;
  text-align: center;
  font-weight: 600;
}

.padding-remember {
  padding-left: 25px;
}

.padding-forgot {
  padding-right: 25px;
}

.remember-forgot {
  /* remember user and forgot password text format */
  background-color: transparent;
  color: #707070;
  font-weight: 600;
  font-size: 11px;
}

.sign-in-button {
  width: 70%;
  padding: 14px;
  font-size: 14px;
  background-color: #358CCB;
  color: #ffffff;
  outline: none;
  border: 1px solid #358CCB;
}

.no-account-text {
  color: #707070;
  text-align: center;
  white-space: nowrap;
  margin-top: 1%;
}

.register-here-text {
  cursor: pointer;
  color: #5e99ff;
  margin-top: 1%;
}

/*mobile medium*/

@media (min-width: 321px) {
  .sign-in-text {
    font-size: 5vw;
  }

  .modal-input {
    width: 270px;
  }

  .padding-remember {
    padding-left: 40px;
  }

  .padding-forgot {
    padding-right: 45px;
  }
}

/* mobile large */

@media (min-width: 425px) {
  .padding-remember {
    padding-left: 50px;
  }

  .padding-forgot {
    padding-right: 55px;
  }
}

/* tablet */

@media (min-width: 426px) {
  .sign-in-text {
    color: #707070;
    font-size: 4vw;
    font-weight: 600;
    text-align: left;
    margin-left: 20%;
    white-space: nowrap;
  }

  .login-section {
    margin-left: 60%;
    /* margin-top: 10%; */
    position: relative;
  }

  .icon-eye {
    padding: 18px;
    right: 10%;
    color: #c7c7c7;
    cursor: pointer;
  }

  .sign-in-button {
    width: 70%;
    padding: 15px;
    font-size: 14px;
    background-color: #358CCB;
    color: #ffffff;
    outline: none;
    border: 1px solid #358CCB;
  }

  .no-account-text {
    color: #707070;
    text-align: center;
    white-space: nowrap;
    margin-top: 5%;
  }

  .register-here-text {
    cursor: pointer;
    color: #5e99ff;
    margin-top: 5%;
  }

  .registration-form {
    margin-bottom: -10px;
    margin-top: 5px;
  }

  .padding-remember {
    padding-left: 18px;
  }

  .padding-forgot {
    padding-right: 18px;
  }
}

/* laptop */

@media (min-width: 769px) {
  .sign-in-text {
    color: #707070;
    font-size: 35px;
    font-weight: 600;
    text-align: left;
    margin-left: 20%;
    white-space: nowrap;
  }

  .login-section {
    margin-left: 60%;
    margin-top: 5%;
    position: relative;
  }

  .sign-in-button {
    width: 70%;
    padding: 15px;
    font-size: 14px;
    background-color: #358CCB;
    color: #ffffff;
    outline: none;
    border: 1px solid #358CCB;
  }

  .icon-eye {
    padding: 10px;
    right: 7%;
    color: #c7c7c7;
    cursor: pointer;
  }

  .input-field {
    width: 79%;
    padding: 18px;
    padding-left: 50px;
    font-size: 14px;
    /*text-align: center;*/
    border-radius: 50px;
    border: 1.2px solid #c7c7c7;
  }

  .icon {
    padding-top: 20px;
    min-width: 60px;
    text-align: center;
    color: #c7c7c7;
    padding: 22px;
    font-size: 14px;
  }

  .icon-eye {
    padding: 21px;
    right: 11%;
    color: #c7c7c7;
    cursor: pointer;
    font-size: 16px;
  }

  .no-account-text {
    color: #707070;
    text-align: center;
    white-space: nowrap;
    margin-top: 5%;
    font-size: 16px;
  }

  .register-here-text {
    cursor: pointer;
    color: #5e99ff;
    margin-top: 5%;
    font-size: 14px;
  }

  .remember-forgot {
    /* remember user and forgot password text format */
    background-color: transparent;
    color: #707070;
    font-weight: 600;
    font-size: 13px;
    margin-top: 10px;
    margin-bottom: 15px;
  }

  .padding-remember {
    padding-left: 50px;
  }

  .padding-forgot {
    padding-right: 60px;
  }
}

/*laptop l */

@media (min-width: 1440px) {
  .sign-in-text {
    color: #707070;
    font-size: 50px;
    font-weight: 600;
    text-align: left;
    margin-left: 20%;
    white-space: nowrap;
  }

  .icon {
    padding-top: 24px;
    min-width: 60px;
    text-align: center;
    color: #c7c7c7;
    padding: 38px;
    font-size: 24px;
    /*margin-right: 10px;*/
  }

  .input-field {
    width: 80%;
    padding: 28px;
    padding-left: 80px;
    font-size: 23px;
    /*text-align: left;*/
    border-radius: 50px;
    border: 1.4px solid #c7c7c7;
    margin-top: 5px;
  }

  .icon-eye {
    padding: 38px;
    right: 10%;
    color: #c7c7c7;
    cursor: pointer;
    font-size: 26px;
  }

  .sign-in-button {
    width: 70%;
    padding: 20px;
    font-size: 24px;
    background-color: #358CCB;
    color: #ffffff;
    outline: none;
    border: 1px solid #358CCB;
    border-radius: 60px;
    margin-top: 4px;
  }

  .no-account-text {
    color: #707070;
    text-align: center;
    white-space: nowrap;
    margin-top: 5%;
    font-size: 22px;
  }

  .register-here-text {
    cursor: pointer;
    color: #5e99ff;
    margin-top: 5%;
    font-size: 22px;
  }

  .remember-forgot {
    /* remember user and forgot password text format */
    font-size: 19px;
    margin-top: 20px;
  }

  .error-message {
    margin-top: 20px;
    font-size: 20px;
  }

  .format-text {
    color: #5a5a5a;
    text-align: center;
    font-size: 28px;
    font-weight: 600;
  }

  .padding-remember {
    padding-left: 60px;
  }

  .padding-forgot {
    padding-right: 70px;
  }
}

/* 4k */

@media (min-width: 2560px) {
  .sign-in-text {
    font-size: 100px;
  }

  .input-field {
    width: 80%;
    padding: 55px;
    padding-left: 150px;
    font-size: 45px;
    border-radius: 90px;
    border: 2px solid #c7c7c7;
    margin-top: 20px;
  }

  .icon {
    padding-top: 24px;
    min-width: 64px;
    text-align: center;
    color: #c7c7c7;
    padding: 85px;
    font-size: 45px;
    /*margin-right: 10px;*/
    padding-left: 70px;
  }

  .icon-eye {
    padding: 85px;
    right: 7%;
    color: #c7c7c7;
    cursor: pointer;
    font-size: 47px;
  }

  .remember-forgot {
    font-size: 35px;
    margin-top: 60px;
    margin-bottom: 60px;
  }

  .sign-in-button {
    width: 70%;
    padding: 40px;
    font-size: 45px;
    background-color: #358CCB;
    color: #ffffff;
    outline: none;
    border: 1px solid #358CCB;
    border-radius: 70px;
    margin-top: 4px;
  }

  .no-account-text {
    white-space: nowrap;
    margin-top: 5%;
    font-size: 40px;
  }

  .register-here-text {
    margin-top: 5%;
    font-size: 40px;
  }

  .error-message {
    margin-top: 30px;
    font-size: 40px;
  }

  .padding-remember {
    padding-left: 110px;
  }

  .padding-forgot {
    padding-right: 130px;
  }
}
</style>
